import styled from "styled-components";

export const PreferencesContainer = styled.div`
  text-align: left;
  margin-top: 10px;
`;

export const ToggleLabel = styled.label`
  font-size: 14px;
`;

export const ToggleInput = styled.input`
  transform: scale(1);
  margin-right: 15px;
  appearance: none;
  background-color: #d3d3d3;
  border: 2px solid ${({ theme }) => theme.colors.darkblue};
  border-radius: 4px;
  width: 20px;
  height: 20px;

  &:checked {
    background-color: ${({ theme }) => theme.colors.darkblue};
    border-color: ${({ theme }) => theme.colors.darkblue};
  }

  &:checked::after {
    content: "🗸";
    display: block;
    text-align: center;
    color: white;
    font-size: 12px;
    line-height: 20px;
  }
`;

export const ToggleGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;

  /* Special styling for only the first checkbox */
  &:first-of-type ${ToggleInput}:checked {
    background-color: rgb(53, 59, 80) !important;
    border-color: #17224d !important;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
`;

export const Banner = styled.div`
  background: white;
  padding: 30px;
  width: 400px;
  font-size: 14px;
  color: #17224d;
  max-width: 90%;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1001;
`;

export const Button = styled.button`
  background: ${({ theme }) => theme.colors.darkblue};
  color: white;
  border: none;
  padding: 10px 20px;
  margin-top: 10px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
`;
